// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 9V3H1V9L23 9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 11.0004V13.3895C22.1372 12.8269 21.1068 12.5 20 12.5C16.9624 12.5 14.5 14.9624 14.5 18C14.5 19.1068 14.8269 20.1372 15.3895 21L1 21V11.0004H23ZM9 17.0001V15.0001L4 15.0001L4 17.0001L9 17.0001Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 17V14H19V17H16V19H19V22H21V19H24V17H21Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-creditcard-add-filled')
export default class CreditcardAddFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'creditcard-add-filled',
    }
  }
}
